import { get } from "lodash"

export const getSelectedModelId = (_, props) => get(props, "modelId")
